module.exports = __webpack_public_path__ + "static/media/background-img-left.ee3434f4.svg";